import * as React from "react";
const SvgFiRrPopcorn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-popcorn_svg__a)">
      <path
        fill="#062147"
        d="M11 6a1 1 0 0 1-1 1 1 1 0 0 0-1 1 1 1 0 0 1-2 0 3 3 0 0 1 3-3 1 1 0 0 1 1 1m3 1a1 1 0 0 0 0 2 1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3m7.923 6.486-1.3 6.5A5.01 5.01 0 0 1 15.721 24H8.279a5.01 5.01 0 0 1-4.9-4.019l-1.3-6.5a4.007 4.007 0 0 1-.05-6.953A4.01 4.01 0 0 1 5.311 3.06a3.456 3.456 0 0 1 3.7-2.016A3.517 3.517 0 0 1 14.66 2a3.48 3.48 0 0 1 2.392 1.115 4.01 4.01 0 0 1 4.921 3.414 4.007 4.007 0 0 1-.05 6.957M8.484 22 8 16.062A2.02 2.02 0 0 0 6 14H4.22l1.117 5.588A3.03 3.03 0 0 0 8.484 22m4.972 0L14 15.978A2 2 0 1 0 10 16l.487 6zm6.324-8H18a2 2 0 0 0-2 2l-.537 6a3.04 3.04 0 0 0 3.2-2.412zM22 10a2 2 0 0 0-1.335-1.874A1 1 0 0 1 20 7.184a2.011 2.011 0 0 0-2.872-1.972 1 1 0 0 1-1.318-.42A1.5 1.5 0 0 0 14.5 4a1.13 1.13 0 0 1-1.529-.762 1.5 1.5 0 0 0-2.739-.526C9.788 3.43 9.122 3.1 8.5 3a1.5 1.5 0 0 0-1.47 1.2 1 1 0 0 1-1.072.8A2 2 0 0 0 4 7a1.05 1.05 0 0 1-.665 1.126A2 2 0 0 0 4 12h2a3.97 3.97 0 0 1 3 1.382 3.994 3.994 0 0 1 5.994-.007A4 4 0 0 1 18 12h2a2 2 0 0 0 2-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-popcorn_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPopcorn;
